import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type EnrolError from 'linced-app/models/enrolments/nz-moe/enrol-error';
import type EnrolLearner from 'linced-app/models/enrolments/nz-moe/enrol-learner';

// Proto: enrolments.NZDexResponse.
export default class DexResponse extends Fragment {
  declare [Type]: 'enrolments/nz-moe/dex-response';

  @attr('number', { defaultValue: 0 })
  declare dexCode: number;

  @attr('string', { defaultValue: '' })
  declare dexInfo: string;

  @attr('string', { defaultValue: '' })
  declare type: string;

  @fragmentArray('enrolments/nz-moe/enrol-error')
  // @ts-expect-error the proto errors field replaces the Fragment errors.
  declare errors: FragmentArray<EnrolError>;

  @fragmentArray('enrolments/nz-moe/enrol-learner')
  declare learners: FragmentArray<EnrolLearner>;

  @attr('string', { defaultValue: '' })
  declare description: string;
}
